module.exports = __webpack_public_path__ + "img/compliance-standards-v5.b04df4bf.jpg";